<template>
  <div>
    <CCard>
      <CCardHeader>
        <strong>User Information</strong>
      </CCardHeader>
      <CCardBody>
        <CForm>
          <CInput
            label="IsAuthenticated"
            :placeholder="isAuthenticated"
            horizontal
            disabled
          />
          <CInput
            label="IsAdministrator"
            :placeholder="user.isAdministrator"
            horizontal
            disabled
          />
          <CInput
            label="Firstname"
            :placeholder="user.firstname"
            horizontal
            disabled
          />
          <CInput
            label="Lastname"
            :placeholder="user.lastname"
            horizontal
            disabled
          />
          <CInput
            label="E-mail"
            :placeholder="user.email"
            horizontal
            disabled
          />
          <CInput
            label="Groups"
            :placeholder="user.groups"
            horizontal
            disabled
          />
          <CInput
            label="Roles"
            :placeholder="user.roles"
            horizontal
            disabled
          />
        </CForm>
      </CCardBody>
    </CCard>

    <svg aria-hidden="true" 
      style="position: absolute; width: 0; height: 0; overflow: hidden;" 
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <symbol id="icon-enterprise" viewBox="0 0 24 24"><g fill-rule="evenodd"><path d="M10 4h2v18h-2v-5H7v5H5V4h2V2h3z"></path><path fill="currentColor" d="M15.5 12a3.5 3.5 0 013.5 3.5V22h-7v-6.5a3.5 3.5 0 013.5-3.5zm0 5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM7 17h3v5H7z"></path></g></symbol>
      <symbol id="icon-error" viewBox="0 0 24 24"><g fill-rule="evenodd"><path d="M15.728 3L21 8.272v7.456L15.728 21H8.272L3 15.728V8.272L8.272 3h7.456zm-2.314 9l3.466-3.466-1.414-1.414L12 10.586 8.536 7.122 7.122 8.536 10.586 12 7.12 15.466l1.414 1.414L12 13.414l3.464 3.464 1.414-1.414L13.414 12z"></path><path fill="currentColor" d="M13.414 12l3.464 3.464-1.414 1.414L12 13.414 8.534 16.88 7.12 15.466 10.586 12 7.122 8.536l1.414-1.414L12 10.586l3.466-3.466 1.414 1.414z"></path></g></symbol>
    </svg>
    <span class="icon" style="width: 48px; height: 48px;">
      <svg>
        <use :xlink:href="'#' +  iconName"></use>
        <!-- <use xlink:href="#icon-enterprise"></use>
        <a :href="'/job/' + r.id"> -->
      </svg>
    </span>
  </div>
</template>

<script>
export default {
  name: 'RequireLogin',
  mounted() {
    console.log('Debug route params')
    console.log(JSON.stringify(this.$route.params))
  },
  computed: {
    isAuthenticated() {
      return this.$store.state.isAuthenticated
    },
    user () {
      return this.$store.state.user
    },
    iconName () {
      return 'icon-enterprise'
    }
  },
  methods: {
  }
}
</script>
